import { LeavePageAlertProvider } from './components/Form/LeavePageAlert';
import { StackSiderViewProvider } from './providers/StackSiderViewProvider';
import { AppRoutes } from './routes';

export function App() {
  return (
    <LeavePageAlertProvider>
      <StackSiderViewProvider>
        <AppRoutes />
      </StackSiderViewProvider>
    </LeavePageAlertProvider>
  );
}
